import { Close } from '@mui/icons-material';
import {
    Box,
    Container,
    IconButton,
    Menu,
    SwipeableDrawer,
    Typography
} from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/logos/icare_acrologo.png';
import useAuthUser from '../../hooks/useAuthUser';

export default function SideMenu({ opener }) {
    const navigate = useNavigate();
    var { isNewUser }  = useAuthUser();

    const [drawerOpen, setOpen] = useState(false);

	const toggleDrawer = (isOpen) => (event) => {
		setOpen(isOpen);
	}

    const navTo = (path) => {
        setOpen(false);
        navigate(path);
    }
    return (
        <>
            <IconButton
                aria-label="close button"
                onClick={toggleDrawer(true)}
                color="text.secondary"
            >
                {opener || <Menu /> }
            </IconButton>
		
            <SwipeableDrawer
                anchor="left"
                open={drawerOpen}
                onClose={toggleDrawer(false)}
                onOpen={toggleDrawer(true)}
                sx={{ width: { xs: '60vw', sm: '20vw' } }}
            >
                <Container className='spread-x' sx={{ py: '32px' }}>
                    <div onClick={() => {navTo('/')}}>
                    <img src={logo} alt='icare app logo' style={{ maxWidth: 100 }}/>
                    </div>
                    <IconButton
                        aria-label="side menu button"
                        onClick={toggleDrawer(false)}
                        color="text.secondary"
                    >
                        <Close />
                    </IconButton>
                </Container>

                <Container sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, justifyContent: 'space-between', pb: 2 }}>
                    <Box>
                    <MenuItem 
                        text={'Home'}
                        path={'/'}
                        navTo={navTo}
                        />
                        {/* <MenuItem 
                            text={'Your Carbon Scorecard'}
                            path={'/profile/edit'}
                            navTo={navTo}
                            disabled={isNewUser}
                        />
                        <MenuItem 
                            text={'Claim Rewards'}
                            path={'/profile/rewards'}
                            navTo={navTo}
                            disabled={isNewUser}
                        />
                        <MenuItem 
                            text={'View Leaderboard'}
                            path={'/profile/leaderboard'}
                            navTo={navTo}
                            disabled={isNewUser}
                        /> */}
                        <MenuItem 
                            text={'Give Feedback'}
                            path={'/feedback/form'}
                            navTo={navTo}
                            disabled={isNewUser}
                        />
                        <MenuItem 
                            text={'About SGFIN'}
                            path={'/about-sgfin'}
                            navTo={navTo}
                        />
                    <MenuItem 
                        text={'Log Out'}
                        path={'/logout'}
                        navTo={navTo}
                    />
                    </Box>
                    
                    <Typography variant='caption'>
                        &copy; {new Date().getFullYear()} 
                        <a href='https://sgfin.nus.edu.sg/' target='_blank' rel="noopener noreferrer" style={{ color: 'black', textDecoration: 'none' }}> NUS Sustainability and Green Finance Institute</a>. <br/>
                        All rights reserved.
                    </Typography>
                </Container>

            </SwipeableDrawer>
        </>
    )
}

const MenuItem = ({ text, path, navTo, disabled }) => {
    return (
        <Box 
            sx={{ 
                py: 2, 
                cursor: 'pointer', 
                px: 1, 
                color: disabled ? '#00000033' : '#000000DE',
                '&:hover': { backgroundColor: disabled ? '' : '#0000000A' } 
            }}
            onClick={(!disabled && path) ? ()=>navTo(path) : ()=>{}}
        >
            <Typography variant='body2'>{text}</Typography>
        </Box>
    )
}